/* unplugin-vue-components disabled */import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.array.push.js";
import { detectEnv } from '@/shared/detect';
import * as repayService from '@/services/repay';
import { Toast } from 'vant';
import formatAmount from '@/shared/formatAmount';
import { formatDate } from '@/shared/formatDate';
import { useUserStore } from '@/stores/modules/user';
export default {
    __name: 'list',
    setup: function(__props) {
        var userStore = useUserStore();
        var router = useRouter();
        var isApp = computed(function() {
            return detectEnv.android;
        });
        var active = ref(0);
        var repayList = ref([]);
        var reqRepayList = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var params, debtRecord, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            params = {
                                kindSort: 1,
                                originPoint: 1
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                repayService.queryRepayList(params)
                            ];
                        case 2:
                            debtRecord = _state.sent().debtRecord;
                            repayList.value = debtRecord;
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            Toast(error.message);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function reqRepayList() {
                return _ref.apply(this, arguments);
            };
        }();
        reqRepayList();
        var goRepay = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(formKey) {
                return _ts_generator(this, function(_state) {
                    router.push({
                        path: '/repay/payment',
                        query: {
                            formKey: formKey
                        }
                    });
                    return [
                        2
                    ];
                });
            });
            return function goRepay(formKey) {
                return _ref.apply(this, arguments);
            };
        }();
        return {
            __sfc: true,
            userStore: userStore,
            router: router,
            isApp: isApp,
            active: active,
            repayList: repayList,
            reqRepayList: reqRepayList,
            goRepay: goRepay,
            formatAmount: formatAmount,
            formatDate: formatDate
        };
    }
};
